import { mapActions, mapState } from 'vuex';

// const ROUTES_TO_HIDE_COUNT = [
//   'portfolio',
// ];

const unreadNotificationMixin = {
  computed: {
    ...mapState('user', [
      'userUnreadNotificationsCount',
    ]),
    userUnreadNotificationsCountHeader() {
      // if (this.$route && ROUTES_TO_HIDE_COUNT.includes(this.$route.name)) return 0;
      return this.userUnreadNotificationsCount;
    },
  },
  methods: {
    ...mapActions('dashboard', ['markNotificationsAsRead']),
    ...mapActions('user', ['setUserUnreadNotificationsCount']),
    clearAllNotifications() {
      this.markNotificationsAsRead();
      this.setUserUnreadNotificationsCount(0);
    },
  },
};


export default unreadNotificationMixin;



// WEBPACK FOOTER //
// ./src/mixins/unreadNotification.js